import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MessageOutboundDetailsComponent from './messageOutbound.component';

const MessageOutboundDetailsModule = angular.module('tinaba.components.services.messageOutbound', [
  uiRouter
])
.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('services.messageOutbound', {
    url: '/messageOutbound',
    template: '<message-outbound-details></message-outbound-details>'
  });
})

.component('messageOutboundDetails', MessageOutboundDetailsComponent);

export default MessageOutboundDetailsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/messageOutbound/messageOutbound.js
 **/